/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getActiveInstrumentSyncEntities} from '../api'

 export const useQueryGetActiveInstrumentSyncEntities = createReactQueryHook('getActiveInstrumentSyncEntities', getActiveInstrumentSyncEntities)
